var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "asct" } }, [
      _c("h2", [_vm._v("特定商法取引に基づく表記")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "「特定商取引に関する法律」第11条（通信販売についての広告）に基づき以下に明示いたします"
        )
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "tile is-ancestor" }, [
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("販売業者・責任者")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v("長谷川 拓也")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("所在地")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v("〒105-0013 東京都港区浜松町2-2-15")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("電話番号")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v("メールでご連絡いただければ開示します。")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tile is-ancestor" }, [
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("販売価格")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v("月額500円")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("支払い時期及び方法")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "Stripe を使用したクレジットカード決済になり、登録した日と月のその日の毎月決済が行われます。"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("役務の提供時期")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v("登録後、ただちに利用が可能です。")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b560925a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b560925a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Asct.vue
// module id = null
// module chunks = 